import { Controller } from "@hotwired/stimulus"
import ga from "../utils/ga"

export default class extends Controller {
  static values = {
    open: Boolean,
  }

  static targets = ["pill", "category", "form", "input"]

  open(e) {
    e.preventDefault()
    this.openValue = true
    this.inputTarget.focus()
  }

  close(e) {
    e.preventDefault()
    this.openValue = false
  }

  selectPill(e) {
    e.preventDefault()
    this.categoryTarget.value = e.currentTarget.dataset.pillValue
    this.pillTargets.forEach((el) => {
      el.removeAttribute("data-selected")
      if (el.dataset.pillValue === this.categoryTarget.value) {
        el.dataset.selected = true
      }
    })

    ga("send", {
      hitType: "event",
      eventCategory: "page-header-top;search bar",
      eventAction: "click;pill",
      eventLabel: this.categoryTarget.value,
    })
  }

  trackSearchEvent() {
    ga("send", {
      hitType: "event",
      eventCategory: "page-header-top;search bar",
      eventAction: "click",
      eventLabel: "Search",
    })
  }
}
